import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const inventoryManagementRoutes = [
  {
    path: 'inventory-management',
    component: SuperAdminDummyRouter,
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/inventoryManagement/list/InventoryListView.vue'),
      },
      {
        path: ':inventoryId',
        component: () =>
          import('@/features/settingsManagement/inventoryManagement/edit/InventoryEditView.vue'),
      },
      {
        path: 'new',
        component: () =>
          import('@/features/settingsManagement/inventoryManagement/edit/InventoryEditView.vue'),
      },
    ],
  },
]
